import reducer from "./reducer";
export { default as CoursesMaster } from "./components/index";
export { default as coursesMasterReducerName } from "./constants";
export default reducer;
